var render = function () {
  var _vm$transaction, _vm$transaction2, _vm$transaction3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tx_row"
  }, [_c('div', {
    staticClass: "info_col id_col"
  }, [_c('span', {
    staticClass: "content"
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('router-link', {
    staticClass: "id monospace",
    attrs: {
      "to": "/tx/".concat((_vm$transaction = _vm.transaction) === null || _vm$transaction === void 0 ? void 0 : _vm$transaction.id, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v(_vm._s(_vm.shortenId(_vm.transaction.id, 6)) + " ")]) : _c('router-link', {
    staticClass: "id monospace",
    attrs: {
      "to": "/tx/".concat((_vm$transaction2 = _vm.transaction) === null || _vm$transaction2 === void 0 ? void 0 : _vm$transaction2.id, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v(_vm._s(_vm.shortenId(_vm.transaction.id, 6)) + " ")]), _c('CopyText', {
    attrs: {
      "value": _vm.transaction.id
    }
  })], 1), _c('div', {
    staticClass: "id_row"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(_vm.transaction.timestamp)))]), _c('span', {
    class: _vm.isAsset ? 'assetType' : 'type'
  }, [_vm.type !== '' ? _c('span', {
    staticClass: "tx_type_label"
  }, [_vm._v(_vm._s(_vm.type))]) : _vm._e()])])]), _c('div', {
    staticClass: "info_col utxo_list"
  }, [_vm.$vuetify.breakpoint.smAndDown ? _c('span', {
    staticClass: "label"
  }) : _vm._l(_vm.inputs, function (input, i) {
    return _c('InputUTXO', {
      key: i,
      attrs: {
        "input": input
      }
    });
  })], 2), _c('div', {
    staticClass: "info_col utxo_list"
  }, [_vm.isGenesisVertex ? [_c('v-btn', {
    staticClass: "dcm_btn",
    attrs: {
      "text": true
    },
    on: {
      "click": _vm.goToTx
    }
  }, [_vm._v(" Explore Genesis Vertex ")])] : _vm._l(_vm.outputs, function (output, i) {
    return _c('OutputUTXO', {
      key: i,
      attrs: {
        "output": output
      }
    });
  }), _c('span', {
    staticClass: "content"
  }, [_vm.outputLength > 2 ? _c('router-link', {
    staticClass: "id monospace",
    attrs: {
      "to": "/tx/".concat((_vm$transaction3 = _vm.transaction) === null || _vm$transaction3 === void 0 ? void 0 : _vm$transaction3.id, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v(_vm._s(_vm.outputLength - 2 + ' more UTXOs') + " ")]) : _vm._e()], 1)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }